import React, { useCallback, useState } from 'react';
import { ReactComponent as Logo } from '../../Shared/svgs/logo.svg'
import { ReactComponent as SocialInstaIcon } from '../../Shared/svgs/brand-instagram.svg';
import { ReactComponent as SocialFbIcon } from '../../Shared/svgs/brand-facebook.svg';
import { ReactComponent as SocialXIcon } from '../../Shared/svgs/brand-x.svg';
import { ReactComponent as SocialLnkdInIcon } from '../../Shared/svgs/brand-linkedin.svg';
import { ReactComponent as Person } from '../../Shared/svgs/person.svg'
import { ReactComponent as QuestionMark } from '../../Shared/svgs/question-mark.svg'
import { ReactComponent as LogOut } from '../../Shared/svgs/export.svg'

import { Link } from 'react-router-dom';
import { logout } from '../../../lib/api/user'
import { useHistory } from "react-router";
import { useLogin } from '../../../lib/hooks/useLogin';

const DashboardWrapper = ({ children, helpLink }) => {
    const loggedIn = useLogin();
    const [mobileExpanded, setMobileExpanded] = useState(false);

    const user = loggedIn && loggedIn.account && loggedIn.account.token;

    const history = useHistory()
    const logoutUser = useCallback(() => {
        logout().then(() => {
            if (window?.mixpanel?.track) {
                window.mixpanel.track("User Logged Out")
            }
            history.push('/login');
        })
    }, [history])

    const onNavigate = () => {
        if (mobileExpanded) {
            setMobileExpanded(false)
        }
    }

    return (
        <div id="dashboard-wrapper" className="flex flex-col min-h-screen">
            <div id="dashboard-header" className="bg-everflow-magenta" style={{ width: '98%', marginLeft: 'auto', marginRight: 'auto', borderRadius: '25px' }}>
                <div className="wrapper items-center">
                    <Link id="navbarlogo" to="/">
                        <Logo id="icon-logo-everflow" height='30' />
                    </Link>
                    <div id="navbarLinks" className={`items-start md:items-center text-everflow-white ${mobileExpanded ? 'flex' : 'hidden'} md:flex flex-col md:flex-row gap-20px justify-items-end pb-4 pt-8 md:py-0`}>
                        {user && (
                            <span id="navbarAccountNo" className="ml-auto text-everflow-white font-bold mr-38px hidden md:inline">{loggedIn.account.customerBusinessName}</span>
                        )}
                        <a id="navbarHelpLink" onClick={() => {
                            if (window?.mixpanel?.track) {
                                window.mixpanel.track("Help link visited");
                            }
                            onNavigate();
                        }} href={helpLink} target="_blank" className="pb-3px flex gap-4" rel="noreferrer">
                            <QuestionMark id="icon-questionmark" className="w-28px m-auto" /><span className="inline md:hidden"> Help Centre</span>
                        </a>
                        {user ? (
                            <>
                                <a onClick={logoutUser} className='pb-3px flex gap-4'><LogOut id="navbarLogOut" className="w-28px m-auto cursor-pointer" /> <span className='flex md:hidden'>Logout</span></a>
                            </>
                        ) : null}
                    </div>
                    <div id="NavbarMobileMenuToggle" className='flex md:hidden'>
                        <img className='ml-auto' src={mobileExpanded ? '/assets/icons/ev-hamburger-x.svg' : '/assets/icons/ev-hamburger-menu.svg'} onClick={() => setMobileExpanded(!mobileExpanded)} />
                    </div>
                </div>
            </div>
            <div id="dashboard-body" className="flex-grow flex">
                <div className="m-auto flex flex-col justify-center h-full w-full">
                    {children}
                </div>
            </div>
            <div id="dashboard-footer" className="bg-everflow-black relative" >
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2" style={{ marginTop: '20px' }}>
                    <a id="footer-link-legal" target="_blank" rel="noreferrer" href="https://everflowutilities.com/legal" className="text-white font-bold hover:text-everflow-grey text-14px">Legal</a>
                </div>

                <div className="wrapper" style={{ paddingTop: '65px', paddingBottom: '60px' }}>
                    <div className="border-t border-bluegray" style={{ paddingBottom: '40px' }}></div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <Logo id="icon-logo-everflow-footer" height='30' className="text-white" />
                        </div>

                        <div className="flex items-center gap-10px">
                            <a id="footer-link-instagram" onClick={() => { if (window?.mixpanel?.track) { window.mixpanel.track("Social Link Visit", { link: "Instagram" }) } }} href="https://www.instagram.com/everflowutilities/" target="_blank" rel="noreferrer"><SocialInstaIcon id="icon-brand-instagram" className="w-20px text-white" /></a>
                            <a id="footer-link-facebook" onClick={() => { if (window?.mixpanel?.track) { window.mixpanel.track("Social Link Visit", { link: "Facebook" }) } }} href="https://www.facebook.com/EverflowUtilities" target="_blank" rel="noreferrer"><SocialFbIcon id="icon-brand-facebook" className="w-16px text-white" /></a>
                            <a id="footer-link-x" onClick={() => { if (window?.mixpanel?.track) { window.mixpanel.track("Social Link Visit", { link: "X" }) } }} href="https://twitter.com/Everflow_util" target="_blank" rel="noreferrer"><SocialXIcon id="icon-brand-x" className="w-20px text-white" /></a>
                            <a id="footer-link-linkedIn" onClick={() => { if (window?.mixpanel?.track) { window.mixpanel.track("Social Link Visit", { link: "LinkedIn" }) } }} href="https://www.linkedin.com/company/10409528" target="_blank" rel="noreferrer"><SocialLnkdInIcon id="icon-brand-linkedIn" className="w-20px text-white" /></a>
                        </div>
                    </div>

                    <div className="border-b border-bluegray" style={{ paddingTop: '50px' }}></div>
                </div>
            </div>
        </div>
    )
}

export default DashboardWrapper
